var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('profile-nav-bar'),_c('profile-user',{on:{"userLogin":_vm.userLogin}}),_c('profile-user-info'),_c('profile-user-orders')],1)}
var staticRenderFns = []

export { render, staticRenderFns }